document.addEventListener(
'DOMContentLoaded',
function(){

if(localStorage.getItem('popupSubmitted'))
{
return;
}

setTimeout(function(){

document
.getElementById('leadPopup')
.classList.add('active');

},10000);

document
.getElementById('closePopup')
.addEventListener(
'click',
function(){

document
.getElementById('leadPopup')
.classList.remove('active');

});

document
.getElementById('submitLead')
.addEventListener(
'click',
async function(){

const name =
document
.getElementById('subscriberName')
.value;

const phone =
document
.getElementById('subscriberPhone')
.value;

if(phone.length < 10){
alert('Enter valid number');
return;
}

try{

await fetch(
'https://shopify-popup-api-production.up.railway.app/subscribe',
{
method:'POST',
headers:{
'Content-Type':
'application/json'
},
body:JSON.stringify({
name,
phone
})
}
);

localStorage.setItem(
'popupSubmitted',
'yes'
);

document
.getElementById('leadSuccess')
.innerHTML =
'Thank you for subscribing';

}
catch(err){

alert(
'Something went wrong'
);

}

});

});